// Admin do canal ScontiPoste
const adminChannelDictEN = {
  adminChannelMenu: "ScontiPoste",
  adminChannelTabConfig: "Settings",
  adminChannelTabSellers: "Managers",
  adminChannelTabSales: "Sales",
  adminChannelTabCashback: "Cashback provision",
  adminChannelUrl: "Showcase link",
  adminChannelUrlHelp: "This is the link ScontiPoste publishes. To know where sales come from, share the link with UTMs.",
  adminChannelUtmUrl: "Link with UTMs",
  adminChannelOpen: "Open showcase",
  adminChannelStatus: "Status",
  adminChannelActive: "Showcase open to the public",
  adminChannelInactive: "Showcase closed",
  adminChannelPercent: "ScontiPoste cashback (%)",
  adminChannelPercentHelp: "Deducted from the seller on every sale. Applies to new orders only.",
  adminChannelSave: "Save",
  adminChannelSaved: "Settings saved",
  adminChannelActiveSellers: "Active Managers: {count}",
  adminChannelOutdated: "{count} Manager(s) have not accepted the current % yet: their products are out of the showcase.",
  adminChannelConfirmPercentTitle: "Change the cashback?",
  adminChannelConfirmPercent: "The cashback goes from {from}% to {to}%. The {count} active Managers must accept the new % in their dashboard; until then their products leave the showcase.",
  adminChannelConfirmPercentAction: "Change to {to}%",
  adminChannelSeller: "Manager",
  adminChannelJoined: "Joined",
  adminChannelTermsPercent: "Accepted %",
  adminChannelProductsMode: "Products",
  adminChannelAllProducts: "Whole shop",
  adminChannelSelectedProducts: "Selected",
  adminChannelListed: "In showcase",
  adminChannelSellerStatus: "Status",
  adminChannelStatusActive: "Active",
  adminChannelStatusOutdated: "Acceptance pending",
  adminChannelStatusLeft: "Out of the channel",
  adminChannelSuspend: "Suspend",
  adminChannelReactivate: "Reactivate",
  adminChannelSuspendTitle: "Suspend Manager?",
  adminChannelSuspendConfirm: "{name}'s products leave the ScontiPoste showcase right away. Orders already placed continue as usual.",
  adminChannelSearchSellers: "Search Manager",
  adminChannelFrom: "From",
  adminChannelTo: "To",
  adminChannelApply: "Filter",
  adminChannelCheckout: "Checkout",
  adminChannelDate: "Date",
  adminChannelBuyer: "Buyer",
  adminChannelOrders: "Orders",
  adminChannelTotal: "Total",
  adminChannelOrigin: "Origin",
  adminChannelNoOrigin: "No UTM",
  adminChannelCheckoutPAID: "Paid",
  adminChannelCheckoutCREATED: "Not completed",
  adminChannelCheckoutFAILED: "Failed",
  adminChannelCheckoutREFUNDED: "Refunded",
  adminChannelCheckoutPARTIALLY_REFUNDED: "Partially refunded",
  adminChannelPaidTotal: "Total paid in the period: {total}",
  adminChannelSearchSales: "Search buyer, order or campaign",
  adminChannelCashbackHelp: "Cashback deducted from sellers when orders are received. Use it to check the Poste Italiane invoice.",
  adminChannelCashbackTotal: "Total provisioned in the period: {total}",
  adminChannelExportCsv: "Export CSV",
  adminChannelBySeller: "By Manager",
  adminChannelOrder: "Order",
  adminChannelAmount: "Amount",
  adminChannelOrderAmount: "Items value",
  adminChannelSearchCashback: "Search Manager or order",
  adminChannelEntryACCRUED: "Provisioned",
  adminChannelEntryREVERSED: "Reversed",
  channelError500439: "The cashback must be between 0 and 100, with up to 2 decimals.",
  channelError500440: "Set a cashback greater than 0 before opening the showcase.",
};

export default adminChannelDictEN;
